import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, throwError, of } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { Token } from '../model/token';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root'
})
export class TokenService {
  private cookieValue: any;
  private emailUrl = environment.api + '/temporarytoken';

  constructor(private http: HttpClient,
    private cookieService: CookieService,
    ) { }

  getTokenById(id: string): Observable<Token> {
      const url = `${this.emailUrl}/${id}`;
      return this.http.get<Token>(url, { withCredentials: true, headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.getToken()}`
      })}).pipe(
        tap(_ => {
          if(_ !== null) {
            console.log(`fetched token id=${_.Id}`);
            localStorage.setItem('pima_email_token', JSON.stringify(_));
          }
        }),
        catchError(this.handleError)
      );
    }

    saveToken(bearer: string) {
      localStorage.setItem('token', bearer);
    }

    getToken(): string {
      return localStorage.getItem('token');
    }

  private handleError(error: HttpErrorResponse) {
    let errorMessage = '';
    console.log(error);
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      errorMessage = 'An error occurred:' + error.error.message;
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      errorMessage = error.error;
      console.error(`Backend returned code ${error.status}, ` + `body was: ${error.error}`);
    }
    // return an observable with a user-facing error message
    return throwError(errorMessage);
  }

}
